import * as Account from 'app/react/entities/accounts/helpers';
import { fetchAll } from './actions';

export const fetchAllForCurrentContext = () => (dispatch, getState) => {
    const state = getState();
    const accountId = Account.getCurrentId(state);
    return dispatch(fetchAll(accountId));
};
